import styled from "styled-components";

export const ItemWrapper = styled("button")<{ isUnread: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  width: 100%;
  border: none;
  cursor: pointer;
  text-align: left;
  background-color: ${({ isUnread }) =>
    isUnread ? "rgba(108, 92, 231, 0.04)" : "transparent"};
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ isUnread }) =>
      isUnread ? "rgba(108, 92, 231, 0.08)" : "rgba(0, 0, 0, 0.02)"};
  }
`;

export const UnreadDot = styled("div")`
  width: 8px;
  height: 8px;
  min-width: 8px;
  border-radius: 50%;
  background-color: #6C5CE7;
  margin-top: 6px;
`;

export const ReadDotPlaceholder = styled("div")`
  width: 8px;
  min-width: 8px;
`;

export const IconWrapper = styled("div")<{ isUnread: boolean }>`
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 50%;
  background-color: ${({ isUnread }) =>
    isUnread ? "rgba(108, 92, 231, 0.12)" : "rgba(0, 0, 0, 0.06)"};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled("div")`
  flex: 1;
  min-width: 0;
`;

export const Title = styled("p")<{ isUnread: boolean }>`
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  font-weight: ${({ isUnread }) => (isUnread ? "600" : "400")};
  color: #2d3436;
`;

export const Body = styled("p")`
  margin: 2px 0 0;
  font-size: 13px;
  line-height: 17px;
  color: rgba(45, 52, 54, 0.6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Timestamp = styled("span")`
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  color: rgba(45, 52, 54, 0.45);
  display: block;
`;
